module.exports = __webpack_public_path__ + "static/media/american.753d3c63.png";